/* eslint-disable no-useless-catch */

import { calculateCalculator } from 'api/mdl14'

export const fecthCalulateCalculator = (payload, callBack) => async () => {
  try {
    const response = await calculateCalculator(payload)
    const { data, status } = response
    if (status === 200 && data) {
      callBack(data)
    }
  } catch (err) {
    throw err
  }
}
